export var breakpoints = {
    'small': 576,
    'medium': 768,
    'bs-large': 992,
    'large': 1092,
    'x-large': 1200,
    'fourteen-fourty': 1440
};